export default __webpack_public_path__ + "static/media/EM0333.34I-41680_-25116_0.dc3561dc.jpg";